import { render, staticRenderFns } from "./PublicacionPreviewView.vue?vue&type=template&id=52146534&"
import script from "./PublicacionPreviewView.vue?vue&type=script&lang=ts&"
export * from "./PublicacionPreviewView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports